import { Breadcrumb, Button, Select } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { useMobileMenu } from "@contexts/MobileMenu/MobileMenu.context";
import { MenuAlt03 } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./Header.module.css";
import type { HeaderProps } from "./Header.types";

export const Header: FC<HeaderProps> = ({
  breadcrumbPaths,
  dropdownOptions,
  onDropdownChange,
  dropdownValue,
}) => {
  const { t } = useCustomTranslation("common");
  const { openMobileMenu } = useMobileMenu();

  return (
    <header className={classes.header}>
      {openMobileMenu && (
        <Button
          aria-label={t("sidebar.mobileMenu")}
          onClick={openMobileMenu}
          size="sm"
          startIcon={MenuAlt03}
          variant="tertiary"
        >
          <span className={classes.menuLabel}>{t("sidebar.mobileMenu")}</span>
        </Button>
      )}
      {dropdownOptions && dropdownOptions?.length > 1 && (
        <Select
          label=""
          onChange={(newValue) => {
            const selectedOption = dropdownOptions.find(
              (option) => option.value === newValue,
            );
            onDropdownChange?.(selectedOption || null);
          }}
          value={dropdownValue?.value || null}
        >
          <Select.Trigger
            className={classes.selectTrigger}
            data-testid="headerGroups"
          />
          <Select.Dropdown className={classes.dropdown}>
            <Select.Options>
              {dropdownOptions?.map((option) => (
                <Select.Option
                  key={option.value}
                  label={option.label}
                  value={option.value}
                />
              ))}
            </Select.Options>
          </Select.Dropdown>
        </Select>
      )}
      {breadcrumbPaths.length > 0 && (
        <Breadcrumb>
          {breadcrumbPaths.map((path, index) => {
            const isSelected = index === breadcrumbPaths.length - 1;
            return (
              <Breadcrumb.Link
                key={path.pathName}
                className={classNames(
                  isSelected && classes.isSelectedBreadcrumbLink,
                )}
                data-testid="breadcrumbLink"
                href={path.path}
                icon={path.pathIcon}
                isSelected={isSelected}
              >
                {path.pathName}
              </Breadcrumb.Link>
            );
          })}
        </Breadcrumb>
      )}
    </header>
  );
};
